import { fromRoot } from './root';

/**
 * Contains all assets from public folder used in js code
 */

export const FAVICON = fromRoot('/favicon.ico');
export const LA_POSTE_LOGO = fromRoot('/img/logo-la-poste.png');
export const LA_POSTE_SHARE_IMAGE = fromRoot('/img/default-share-image.jpg');
